import { detectDevice, DeviceType } from "./detectDevice"

export const getAppPostLink = ( postID: string ) => {
    const device = typeof window !== 'undefined' ? detectDevice() : {} as DeviceType
    const iOSAppDeepLinkURL = `club-cloud://--/post?postPk=${ postID }&fromExternal=true`
    const androidAppDeepLink = `intent://--/post?postPk=${ postID }#Intent;scheme=club-cloud;package=jp.club_cloud.clubcloud;end;`
    const appLink = device.isiOS ? iOSAppDeepLinkURL : device.isAndroid ? androidAppDeepLink : ""
    return appLink
}
